import React from 'react';
import { Switch, SwitchProps } from '@mui/material';
import { FormikProps } from 'formik';

interface IFormikSwitch {
  name: string;
  formik: FormikProps<any>;
  handleChange?: any;
}
export const FormikSwitch = ({
  name,
  formik,
  dataPup,
  handleChange,
  ...rest
}: IFormikSwitch & SwitchProps & { dataPup?: string }) => {
  const formikProps = formik.getFieldProps(name);
  if (handleChange) {
    return (
      <Switch
        {...rest}
        {...formikProps}
        onChange={handleChange}
        inputProps={{ 'data-pup': dataPup ?? undefined } as any}
        checked={formikProps.value}
      />
    );
  }
  return (
    <Switch
      {...rest}
      {...formikProps}
      inputProps={{ 'data-pup': dataPup ?? undefined } as any}
      checked={formikProps.value}
    />
  );
};
